/* eslint-disable no-return-assign */
import clonedeep from 'lodash.clonedeep';

const state = {
	steps: [],
	staticSteps: [],
	allProducts: [],
	stepsProducts: {},
	test: '',
};

const mutations = {
	setWfSteps: (state, wfs) => (state.steps = wfs),

	setWfStep: (state, wfs) => state.steps.splice(getters.wfsStepIndex(state)(wfs.name), 1, wfs),

	setWfStaticSteps: (state, wfs) => (state.staticSteps = wfs),

	setCustomProdDesc: (state, {stIndex, cpIndex, desc}) =>
		(state.steps[stIndex].products[cpIndex].customContent.desc = desc),

	setToggleEnabledState: (state, {pos, prevState}) => (state.steps[pos].stepEnabled = prevState),

	addCustomStep: (state, {pos, wfs}) => state.steps.splice(pos, 0, wfs),

	setCustomStepName: (state, {pos, name}) => (state.steps[pos].name = name),

	setCustomStepDesc: (state, {pos, desc}) => (state.steps[pos].customContent.desc = desc),

	setLabNotes: (state, {pos, desc}) => (state.steps[pos].labNotes.desc = desc),
	setAllProducts: (state, products) => (state.allProducts = products),
	setStepsProducts: (state, stepsProducts) => (state.stepsProducts = stepsProducts),
};

const actions = {
	// commits all workflow steps
	setWfSteps: ({commit}, wfs) => commit('setWfSteps', clonedeep(wfs)),

	// commits single workflow step
	setWfStep: ({commit}, wfs) => commit('setWfStep', wfs),

	// clones all workflow steps to static steps
	setWfStaticSteps: ({commit}, wfs) => commit('setWfStaticSteps', clonedeep(wfs)),

	// commits description for custom product
	setCustomProdDesc: ({commit}, {name, key, desc}) => {
		const {stIndex, cpIndex} = getters.wfStepAndProductIndex(state)({name, key});
		return commit('setCustomProdDesc', {stIndex, cpIndex, desc});
	},

	// toggles hide/show for given step
	setToggleEnabledState: ({commit}, name) => {
		const pos = getters.wfsStepIndex(state)(name);
		const prevState = !getters.wfStep(state)(name).stepEnabled;
		commit('setToggleEnabledState', {pos, prevState});
	},

	// addes a custom step to the workflow
	addCustomStep: ({commit}, {name, wfs}) =>
		commit('addCustomStep', {pos: getters.wfsStepIndex(state)(name) + 1, wfs}),

	// updates custom steps name
	setCustomStepName: ({commit}, {oldName, name}) => {
		commit('setCustomStepName', {pos: getters.wfsStepIndex(state)(oldName), name});
	},

	// updates custom steps description
	setCustomStepDesc: ({commit}, {name, desc}) =>
		commit('setCustomStepDesc', {pos: getters.wfsStepIndex(state)(name), desc}),

	setLabNotes: ({commit}, {name, desc}) => commit('setLabNotes', {pos: getters.wfsStepIndex(state)(name), desc}),
	setAllProducts: ({commit}, products) => commit('setAllProducts', clonedeep(products)),
	setStepsProducts: ({commit}, stepsProducts) => commit('setStepsProducts', clonedeep(stepsProducts)),
};

const getters = {
	// gets all steps
	wfSteps: (state) => clonedeep(state.steps),

	// gets single step
	wfStep: (state) => (stepName) => clonedeep(state.steps.find((step) => step.name === stepName)),

	// gets the index of a step
	wfsStepIndex: (state) => (stepName) => state.steps.findIndex((step) => step.name === stepName),

	// gets index of step and prouduct
	wfStepAndProductIndex:
		(state) =>
		({name, key}) => {
			const stIndex = getters.wfsStepIndex(state)(name);
			const cpIndex = state.steps[stIndex].products.findIndex((prod) => prod.key === key);
			return {stIndex, cpIndex};
		},

	// gets all steps from cloned workflow
	wfStaticSteps: (state) => state.staticSteps,

	// gets name of product by key
	productName: (state, getters, rootState, rootGetters) => async (key) => {
		const allSteps = clonedeep(getters.wfSteps);

		for (const step of allSteps) {
			if (step?.customContent) continue;
			for (const product of step.products) {
				if (product.key === key) return product.name[rootState.LANG];
			}
		}
	},

	// gets product by id
	productById: (state, getters) => (key) => {
		const allSteps = clonedeep(getters.wfSteps);

		for (const step of allSteps) {
			if (step?.customContent) continue;
			for (const product of step.products) {
				if (product.key === key) return clonedeep(product);
			}
		}
	},
	allProducts: (state) => {
		return state.allProducts;
	},
	stepsProducts: (state) => {
		return state.stepsProducts;
	},
	stepProducts: (state) => (step) => {
		return state.stepsProducts[step];
	},

	// gets keys for every product that is selected in the workflow
	allSelectedProductKeys: (state, getters) => {
		const selectedProducts = new Set();

		for (const wfs of getters.wfSteps) {
			if (wfs?.selected) for (const sel of wfs.selected) selectedProducts.add(sel.initial);
		}
		return [...selectedProducts];
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
